var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYtshortengagementimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7576_49782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4502 1.31679L5.44305 6.54535C3.46111 7.78623 2.79595 11.4666 5.2758 13.2723C5.88333 13.7147 6.03237 15.0415 5.45905 15.5274C2.72928 17.8408 3.61344 20.9061 5.72209 22.2594C7.88652 23.6485 10.5718 22.1212 12.8469 20.9218L18.5599 17.9101C19.2974 17.5212 20.0162 17.0569 20.5 16.3777C22.1338 14.0839 21.1037 11.8712 19.5499 10.6954C18.9566 10.2464 18.749 8.90796 19.3864 8.52411C19.6843 8.34474 19.9012 8.2041 19.9931 8.10964C23.3788 4.33822 18.9859 -0.161778 15.4502 1.31679Z",
    stroke: "#F61C0D",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1016 15.4605V9.27232C10.1016 9.15421 10.2317 9.08243 10.3316 9.14545L15.298 12.279C15.3919 12.3382 15.3911 12.4754 15.2965 12.5336L10.3301 15.5883C10.2302 15.6498 10.1016 15.5778 10.1016 15.4605Z",
    stroke: "#F61C0D",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7576_49782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtshortengagementimg);
export default __webpack_public_path__ + "static/media/yt short engagement img.4a17e684c1859aeea0837513f3f80ed4.svg";
export { ForwardRef as ReactComponent };